import { CloudCruiseRunType } from "@/src/models/cloudcruise-run";
import type { WorkersCompReferralPolicy } from "@/src/models/workers-comp-referral";

export const BALANCE_HEALTH_WORKERS_COMP_TASK_NOTE =
  "Workers comp referral - Valerie does not text workers comp patients. Please review and schedule.";

/**
 * Keep the imports here to light model modules, and out of `comms-escalation.ts`: client components
 * gate on this policy, and that file reaches RingCentral through `routing.ts`, so it cannot be
 * bundled for the browser.
 */
export const BALANCE_HEALTH_WORKERS_COMP_POLICY: WorkersCompReferralPolicy = {
  schedulingNotice: "Workers' comp referral — the clinic schedules this one.",
  escalation: {
    note: BALANCE_HEALTH_WORKERS_COMP_TASK_NOTE,
    runType: CloudCruiseRunType.BALANCE_MODMED_WORKERS_COMP_TASK_CREATE,
  },
};
